import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_einvoice_email_ocr_doc_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  app_file_item_guid: fromDatatype.GuidDataFieldInterface;
  ocr_line_output_json: any;
  item_code: fromDatatype.VarcharDatatypeInterface;
  item_name: fromDatatype.VarcharDatatypeInterface;
  item_classification: fromDatatype.VarcharDatatypeInterface;
  item_description: fromDatatype.TextDatatypeInterface;
  qty: fromDatatype.NumericDatatypeInterface;
  unit_price_txn: fromDatatype.NumericDatatypeInterface;
  amount_txn: fromDatatype.NumericDatatypeInterface;
  amount_net: fromDatatype.NumericDatatypeInterface;
  amount_discount: fromDatatype.NumericDatatypeInterface;
  discount_rate: fromDatatype.NumericDatatypeInterface;
  amount_tax: fromDatatype.NumericDatatypeInterface;
  tax_rate: fromDatatype.NumericDatatypeInterface;
  confidence_level: fromDatatype.NumericDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_fi_einvoice_email_ocr_doc_line_RowClass implements bl_fi_einvoice_email_ocr_doc_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  app_file_item_guid: fromDatatype.GuidDataFieldInterface;
  ocr_line_output_json: any;
  item_code: fromDatatype.VarcharDatatypeInterface;
  item_name: fromDatatype.VarcharDatatypeInterface;
  item_classification: fromDatatype.VarcharDatatypeInterface;
  item_description: fromDatatype.TextDatatypeInterface;
  qty: fromDatatype.NumericDatatypeInterface;
  unit_price_txn: fromDatatype.NumericDatatypeInterface;
  amount_txn: fromDatatype.NumericDatatypeInterface;
  amount_net: fromDatatype.NumericDatatypeInterface;
  amount_discount: fromDatatype.NumericDatatypeInterface;
  discount_rate: fromDatatype.NumericDatatypeInterface;
  amount_tax: fromDatatype.NumericDatatypeInterface;
  tax_rate: fromDatatype.NumericDatatypeInterface;
  confidence_level: fromDatatype.NumericDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
